export default "__VITE_ASSET__a6a26586__"